import { getSupabase } from '@trader-dashboard/database';
async function getByAccount(accountId) {
    const supabase = getSupabase();
    const { data, error } = await supabase
        .from('transactional_orders')
        .select('*')
        .eq('account_id', accountId)
        .order('time', { ascending: false });
    if (error)
        throw new Error(`Failed to fetch transactional orders: ${error.message}`);
    return data || [];
}
async function linkToTransaction(transactionalOrderId, fundsTransactionId) {
    const supabase = getSupabase();
    const { error } = await supabase
        .from('transactional_orders')
        .update({ linked_transaction_id: fundsTransactionId })
        .eq('id', transactionalOrderId);
    if (error)
        throw new Error(`Failed to link transaction: ${error.message}`);
}
async function unlinkTransaction(transactionalOrderId) {
    const supabase = getSupabase();
    const { error } = await supabase
        .from('transactional_orders')
        .update({ linked_transaction_id: null })
        .eq('id', transactionalOrderId);
    if (error)
        throw new Error(`Failed to unlink transaction: ${error.message}`);
}
export const TransactionalOrdersApi = {
    getByAccount,
    linkToTransaction,
    unlinkTransaction,
};
